const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';

const TIMEOUT_SEC = 10;

const RES_PER_PAGE = 10;

const KEY = '01bb1bc0-6ba1-4615-bb6e-34f6cc2649e4';

const MODAL_CLOSE_SEC = 2.5;

export { API_URL, TIMEOUT_SEC, RES_PER_PAGE, KEY, MODAL_CLOSE_SEC };
